import {z} from 'zod/v4';
import {LocalizedStringSchema} from './localized';

export const TemplateValueSchema = z.object({
  $template: z.union([LocalizedStringSchema, z.string()]),
});
